export default __webpack_public_path__ + "static/media/loan.cb6574a7.jpg";